import { createContext, useContext, useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import db from "../firebase/firebaseConfig"; 

import defaultLogo from "../assets/Digitalcoreweb Gradient Tech Logo.png";

const LocalContext = createContext();

export const DEFAULT_SITE_PHONE = {
  localFormat: "+49 3378 5273011",
  intlFormat: "+4933785273011",
};

export const LocalProvider = ({ children }) => {
  const [showCallModal, setShowCallModal] = useState(false);
  const [currentTFN, setCurrentTFN] = useState({
    intlFormat: DEFAULT_SITE_PHONE.intlFormat,
    localFormat: DEFAULT_SITE_PHONE.localFormat,
    popup: false,
  });
  const [popupEnabled, setPopupEnabled] = useState(false);
  const [webinfo, setwebinfo] = useState({
    name: "Digitalcoreweb",
    phone: DEFAULT_SITE_PHONE.localFormat,
    phonecall: DEFAULT_SITE_PHONE.intlFormat,
    email: "contact@digitalcoreweb.com",
    address: "India",
    logo: defaultLogo,
    logowhite: defaultLogo,
  });

  useEffect(() => {
    const fetchTFN = async () => {
      try {
        const docRef = doc(db, "siteNumbers", "digitalcoreweb.com");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          const popupValue = Boolean(data.popup);
          setCurrentTFN({
            intlFormat: data.numberIntl || DEFAULT_SITE_PHONE.intlFormat,
            localFormat: data.numberLocal || DEFAULT_SITE_PHONE.localFormat,
            popup: popupValue,
          });
          setPopupEnabled(popupValue);
        } else {
          setCurrentTFN({ ...DEFAULT_SITE_PHONE, popup: false });
          setPopupEnabled(false);
        }
      } catch (error) {
        console.error("Error fetching TFN: ", error);
        setCurrentTFN({ ...DEFAULT_SITE_PHONE, popup: false });
        setPopupEnabled(false);
      }
    };

    fetchTFN();
  }, []);

  useEffect(() => {
    setwebinfo((prevWebinfo) => ({
      ...prevWebinfo,
      phone: currentTFN.localFormat,
      phonecall: currentTFN.intlFormat,
      popup: currentTFN.popup,
    }));
  }, [currentTFN]);

  return (
    <LocalContext.Provider
      value={{
        webinfo,
        setwebinfo,
        showCallModal,
        setShowCallModal,
        popupEnabled,
        setPopupEnabled,
      }}
    >
      {children}
    </LocalContext.Provider>
  );
};

export const useLocalContext = () => useContext(LocalContext);
